(function($, undefined) {

    'use strict';
    var recaptchaKey = "6LcB2hUqAAAAAJKM4KosE-a9hR2_wtrYoUXDxLrs"; // Production

    var renderCaptcha = function() {
        var $render = $(".account_creation_recaptcha");
        if ($render.length && typeof grecaptcha === "object") {
            grecaptcha.ready(function() {
                $render.each(function() {
                    var _ = this;
                    var createForm = $(_).closest(".create-account-form");
                    var widgetId = grecaptcha.render(_, {
                        'sitekey': recaptchaKey,
                        'size': 'invisible',
                        'badge': 'bottomleft',
                        'callback': function(response) {
                            var email = createForm.find('input[name="email"]').val();
                            var fName = createForm.find('input[name="firstName"]').val();
                            var lName = createForm.find('input[name="lastName"]').val();
                            createForm.find('.account_creation_recatpcha_token').val(response);
                            session.save("regEmail", email, function() {
                                session.save("regFName", fName, function() {
                                    session.save("regLName", lName, function() {
                                        createForm.submit();
                                    });
                                });
                            });
                        }
                    });
                    createForm.attr("data-widget-id", widgetId);
                });
            });
        }
    };

    var createAccount = function(e) {
        e.preventDefault();
        var createForm = $(e.currentTarget).closest(".create-account-form");
        formValidator.validateForm(createForm);
        if (!createForm.hasClass('has-error')) {
            grecaptcha.execute(createForm.attr("data-widget-id"));
        } else {
            return false;
        }
    };

    var init = function() {
        renderCaptcha();
        $(".create-account-form .register-btn").on("click", createAccount);
    };

    $(window).on("load", init);

})(jQuery);
